/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/
export const APP_CONFIG_QUERY = `
  name
  logoIcon
  logoLargeIcon
  appVersions {
    appId
    appUpdateUrl
    platform
    versionMin
    versionLatest
  }
  defaultEnv
  defaultChar
  ttsDefault
  disableSOS
  disableDevTools
  presurveyUrl
  postsurveyUrl
  defaultGoal
  defaultTopic
  defaultCohort
  defaultIntro
  disabledGoals
  disabledTopics
  enabledGoals
  enabledTopics
  priorityGoals
`;
export const GOAL_QUERY = `
  id
  name
  desc
  hidden
  deleted
  createdAt
  updatedAt
  org
  topics
  plans
  survey
  learnerTypes
  apiOverrides {
    type
    url
    accessHeaders { name value }
  }
`;
export const TOPIC_QUERY = `
  id
  name
  desc
  hidden
  deleted
  createdAt
  updatedAt
  org
  recommender
  lessons
  requiredLessons
  prerequisiteTopics
  knowledgeComponents { kc relevance }
  attributeRelevance { name value }
`;

export const MCQ_QUERY = `
  question {
    type
    question
    imagePath
    imageHeader
    startTime
    endTime
  }
  answers {
    answerText
    answerFeedback
    isCorrect
  }
  hints
  isRandomized
  scoreMode
  relatedLessons
`;
export const RESOURCE_QUERY = `
  id
  uri
  duration
  explorationLevel
  license
  firstTimeCategory
  firstTimeParams
  knowledgeComponents { kc relevance }
  assets {
    name type uri duration
    inlineMcq { ${MCQ_QUERY} }
    inlineOpentutor { lessonId }
  }
  inlineMcq { ${MCQ_QUERY} }
  inlineOpentutor { lessonId }
`;
export const LESSON_QUERY = `
  id
  name
  desc
  hidden
  deleted
  createdAt
  updatedAt
  org
  type
  downloadable
  randomizeResources
  remediationScore
  remedialLessons
  learnerTypes
  remedialRequirements { type match matchValidValues greaterPreferred greaterCompared }
  traitRequirements { type match matchValidValues greaterPreferred greaterCompared }
  resources {
    ${RESOURCE_QUERY}
  }
`;

export const KC_QUERY = `
  id
  name
  desc
  deleted
`;
export const LEARNER_TYPE_QUERY = `
  id
  name
  desc
  deleted
  createdAt
  updatedAt
  characteristics
`;
export const DIALOGUE_MESSAGE_QUERY = `
  id
  text
  type
  animation
  audioText
  audioFile
`;

export const INTRO_QUERY = `
  id
  name
  desc
  deleted
  createdAt
  updatedAt
  slides {
    title
    type
    content
    dialogue { ${DIALOGUE_MESSAGE_QUERY} }
    actions { name value }
    conditions { name value }
  }
`;
export const PLAN_QUERY = `
  id
  name
  desc
  deleted
  createdAt
  updatedAt
  sections {
    name
    lesson
    header
    fields {
      header
      entries {
        type
        placeholder
        isOptional
      }
    }
  }
`;
export const SURVEY_QUERY = `
  id
  name
  desc
  deleted
  createdAt
  updatedAt
  questions {
    type
    question
    randomizeChoices
    selectMultiple
    preconditions {
      name operator value
    }
    choices {
      text
      deltas { name value }
      event { name value }
      validation {
        regex
        requiredRegex
        wordCount
        minWordCount
        characterCount
        minCharacterCount
        feedback {
          positive {
            ${DIALOGUE_MESSAGE_QUERY}
          }
          negative {
            ${DIALOGUE_MESSAGE_QUERY}
          }
        }
      }
    }
    dialogue {
      ${DIALOGUE_MESSAGE_QUERY}
    }
  }
  specialEventConditions {
    name operator value
  }
`;

export const USER_QUERY = `
  id
  name
  email
  userRole
  lastLoginAt
`;
export const ORG_QUERY = `
  id
  name
  desc
  hidden
  deleted
  createdAt
  updatedAt
  accessCode
  members { user role }
  config { ${APP_CONFIG_QUERY} }
`;
